import React, { PropTypes } from 'react';
import Overview from './overview/overview';
import Description from './description';
import PointsTable from './points-tables/points-tables';
import Translate from 'react-translate-component';
class LoyaltyPointsView extends React.Component {

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  render () {
    return (<div className='loyalty-points-overview-container no-padding'>
      <Translate className='loyalty-points-overview-title' content='LOYALTY_POINTS_TITLE' />
      <Overview points={this.context.user.loyaltyPoints} />
      <Description />
      <PointsTable />
    </div>);
  }
}

export default LoyaltyPointsView;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/loyalty-points-view.js
 **/